document.addEventListener("DOMContentLoaded", function () {
  // Run for every timer container found
  const containers = document.querySelectorAll('.announcmentCountdownEndDate');
  if (!containers.length) return;

  const pad2 = (n) => String(n).padStart(2, '0');

  // Robust parser: accepts 31.12.2025 23:59:59, 31/12/2025 23:59:59, 31-12-2025 23:59:59
  function toTimestamp(dateString) {
    const trimmed = String(dateString || '').trim();
    if (!trimmed) return NaN;

    const parts = trimmed.split(/\s+/); // [date, time?]
    const datePart = parts[0];
    const timePart = parts[1] || '00:00:00';

    const [day, month, year] = datePart.split(/[./-]/).map(Number);
    if (!day || !month || !year) return NaN;

    const [hh = 0, mm = 0, ss = 0] = timePart.split(':').map(Number);

    // Construct via numeric Date to avoid locale/ISO quirks (uses local time)
    return new Date(year, month - 1, day, hh, mm, ss).getTime();
  }

  function makeTimer(container) {
    const endAttr = container.getAttribute('data-endtime');
    const endTs = toTimestamp(endAttr);
    if (isNaN(endTs) || endTs < 0) {
      console.error('Invalid end date:', endAttr);
      return null;
    }

    const refs = {
      days: container.querySelector('.days_timer__js'),
      hours: container.querySelector('.hours_timer__js'),
      minutes: container.querySelector('.mins_timer__js'),
      seconds: container.querySelector('.secs_timer__js'),
    };

    // Ensure required nodes exist
    if (!refs.days || !refs.hours || !refs.minutes || !refs.seconds) {
      console.warn('Countdown elements missing in container:', container);
      return null;
    }

    function renderRemaining(msRemaining) {
      let s = Math.floor(msRemaining / 1000);

      const days = Math.floor(s / 86400);
      s %= 86400;

      const hours = Math.floor(s / 3600);
      s %= 3600;

      const minutes = Math.floor(s / 60);
      const seconds = s % 60;

      // Zero-pad hours/minutes/seconds; pad days to at least 2 for consistent UI
      refs.days.textContent = pad2(days);
      refs.hours.textContent = pad2(hours);
      refs.minutes.textContent = pad2(minutes);
      refs.seconds.textContent = pad2(seconds);
      $('.annocunmentWithTimer').addClass('active');
    }

    let intervalId;

    function tick() {
      const now = Date.now();
      const remaining = endTs - now;

      if (remaining <= 0) {
        renderRemaining(0);
        clearInterval(intervalId);
        const announcementEl = container.closest('.announcement');
        if (announcementEl) announcementEl.style.display = 'none';
        console.log('Timer ended');
        return;
      }

      renderRemaining(remaining);
    }

    // Initial draw + start interval
    tick();
    intervalId = setInterval(tick, 1000);
    return intervalId;
  }

  // Initialize all timers
  containers.forEach(makeTimer);
});
